import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import Services from "../components/Services";
import Manifesto from "../components/Manifesto";
import Gallery from "../components/Gallery";
import Reviews from "../components/Reviews";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="bg-[#030303]">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Services />
      <Manifesto />
      <Gallery />
      <Reviews />
      <Contact />
      <Footer />
    </div>
  );
}
